class SizeSearchPicker extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.size-search-input');
    this.list = this.querySelector('.size-search-results');
    this.wrapper = this.closest('.varient-model-wrapper');
    this.fieldset = this.closest('fieldset');
    this.currentItems = [];
    this.activeIndex = -1;

    // if (!this.input || !this.list || !this.fieldset) return;
    if (!this.input || !this.list || !this.fieldset || !this.wrapper) return;

    this.radios = Array.from(this.fieldset.querySelectorAll('.varient-class input[type="radio"]'));
    if (!this.radios.length) return;

    this.items = this.radios.map((radio) => ({
      value: radio.value,
      radio,
      isSample: radio.dataset.isSample === 'true'
    }));

    this.sampleItem = this.items.find((item) => item.isSample) || null;

    // Input always starts empty, and Add to Cart starts disabled — nothing is
    // pre-selected until the customer actively picks a size.
    const checked = this.radios.find((r) => r.checked);

    if (checked) {
    // A variant was explicitly selected via the URL (?variant=...) — restore it.
    // Leave the Add to Cart button as the server already rendered it, since
    // that's based on this same selected variant's availability.
    this.input.value = checked.value;
    } else {
    // Fresh page load with no variant chosen yet.
    this.input.value = '';
    this.setAddButtonDisabled(true);
    }

    this.wrapper.classList.add('size-search-active');

    this.input.addEventListener('input', this.onInput.bind(this));
    this.input.addEventListener('focus', this.onInput.bind(this));
    this.input.addEventListener('keydown', this.onKeyDown.bind(this));
    document.addEventListener('click', this.onDocumentClick.bind(this));
  }

  getAddButton() {
    const form = document.getElementById(`product-form-${this.dataset.section}`);
    return form ? form.querySelector('[name="add"]') : null;
  }

  setAddButtonDisabled(disabled) {
    const addButton = this.getAddButton();
    if (!addButton) return;
    if (disabled) {
      addButton.setAttribute('disabled', 'disabled');
    } else {
      addButton.removeAttribute('disabled');
    }
  }

  onInput() {
    const query = this.input.value.trim().toLowerCase();

    if (!query) {
      this.clearSelection();
      this.showDefaultList();
      return;
    }

    let matches = this.items.filter(
      (item) => !item.isSample && item.value.toLowerCase().includes(query)
    );

    if (this.sampleItem && !matches.includes(this.sampleItem)) {
      matches = [this.sampleItem, ...matches];
    }

    this.renderList(matches);
  }

  showDefaultList() {
    const rest = this.items.filter((item) => !item.isSample);
    const list = this.sampleItem ? [this.sampleItem, ...rest] : rest;
    this.renderList(list);
  }

  clearSelection() {
    const hadSelection = this.radios.some((r) => r.checked);
    if (!hadSelection) return;

    this.radios.forEach((r) => { r.checked = false; });
    this.setAddButtonDisabled(true);

    const url = new URL(window.location.href);
    url.searchParams.delete('variant');
    window.history.replaceState({}, '', url);
  }

  renderList(items) {
    this.activeIndex = -1;
    this.currentItems = items;

    if (!items.length) {
      this.hideList();
      return;
    }

    this.list.innerHTML = items
      .map(
        (item, index) => `
        <li role="option" data-index="${index}" class="${item.isSample ? 'is-sample' : ''}">
          ${item.value}
        </li>`
      )
      .join('');

    this.list.hidden = false;

    this.list.querySelectorAll('li').forEach((li) => {
      li.addEventListener('mousedown', (e) => {
        e.preventDefault(); // stop the input from blurring before the click registers
        this.selectItem(this.currentItems[Number(li.dataset.index)]);
      });
    });
  }

  onKeyDown(event) {
    if (this.list.hidden || !this.currentItems.length) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.activeIndex = Math.min(this.activeIndex + 1, this.currentItems.length - 1);
      this.highlight();
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.activeIndex = Math.max(this.activeIndex - 1, 0);
      this.highlight();
    } else if (event.key === 'Enter') {
      event.preventDefault();
      if (this.activeIndex >= 0) this.selectItem(this.currentItems[this.activeIndex]);
    } else if (event.key === 'Escape') {
      this.hideList();
    }
  }

  highlight() {
    this.list.querySelectorAll('li').forEach((li, i) => {
      li.classList.toggle('is-active', i === this.activeIndex);
    });
  }

  selectItem(item) {
    item.radio.checked = true;
    // Bubbles to <variant-radios>, which runs its own onVariantChange
    // synchronously (price, sku, url) — that part we don't need to duplicate.
    item.radio.dispatchEvent(new Event('change', { bubbles: true }));
    this.input.value = item.value;
    this.hideList();
    this.input.blur();

    // onVariantChange disables Add to Cart immediately and only re-enables it
    // after an async fetch resolves. Since we already know a valid variant was
    // picked from our own list, correct the button state right away instead
    // of waiting on that network round-trip.
    const variantRadios = this.closest('variant-radios');
    if (variantRadios && variantRadios.currentVariant) {
      this.setAddButtonDisabled(!variantRadios.currentVariant.available);
    }
  }

  hideList() {
    this.list.hidden = true;
    this.list.innerHTML = '';
    this.currentItems = [];
    this.activeIndex = -1;
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.hideList();
  }
}

// customElements.define('size-search-picker', SizeSearchPicker);

if (!customElements.get('size-search-picker')) {
  customElements.define('size-search-picker', SizeSearchPicker);
}